export default __webpack_public_path__ + "static/services-button-pattern-4fe7ae5c4bca05a2151a74757dbaaada.svg";